module.exports = __webpack_public_path__ + "static/TypingAwayCoffee_prog-984ab50c030ca215b1fd758d781f01f3.jpg";